module.exports = __webpack_public_path__ + "static/q5answer1_donut_wishmas-c28cf558c4212e9b2269f69d64e3770d.jpg";